import { selectFocusedViewFilter } from "owa-mail-triage-table-utils";
import { getFocusedFilterForTable, getSelectedTableView } from "owa-mail-list-store";
import type FocusedViewFilter from "owa-service/lib/contract/FocusedViewFilter";

/**
 * Called when F/O rollup is clicked
 */
export default function onFocusedOtherRollupClicked(): void {
    // - Switch to target Focused or Other pivot
    const targetPivotToSwitchTo = getFocusedFilterForTable(getSelectedTableView()) == 0
        ? 1 : 0;
    selectFocusedViewFilter(targetPivotToSwitchTo, "FocusedOtherRollup");
}
